<template>
  <div style="margin-left: 1em">
    <moow-button
    :class="[{ 'toggle-selected': initialState}]"
              :type="['toggle', 'left']" :btnText="btnTitleOn" @mClick="toggleOn(true)"/>
    <moow-button
    :class="[{ 'toggle-selected': !initialState}]"
              :type="['toggle', 'right']" :btnText="btnTitleOff" @mClick="toggleOn(false)"/>
  </div>
</template>
<script>
export default {
  props: {
    initialState: {
      type: Boolean,
      required: true
    },
    btnTitleOn: {
      type: String,
      required: true
    },
    btnTitleOff: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      onState: true
    };
  },
  watch:{
  },
  computed: {

  },
  created() {
    if (this.initialState == true || this.initialState == false)
      this.onState = this.initialState;
  },
  methods: {
    toggleOn(state) {
      this.onState = state;
      this.$emit("emitToggleOn", state);
    }
  }
};
</script>
<style scoped lang="scss">
@import "../../../assets/styles/variables.scss";
@import "../../../assets/styles/global.css";



.toggle-selected {
  background-color: #F1F4F8 !important;
  color: #6F828E !important;
}

.toggle-selected :hover{
  cursor: not-allowed;
}

</style>



// WEBPACK FOOTER //
// src/components/interface/buttons/toggleSwitch.vue